interface CircularProgressProps {
    number: number;
    progress: number; // 0-100
}

const SVG_SIZE = 40;
const CENTER = 20;
const ARC_RADIUS = 18;
const TRACK_STROKE_WIDTH = 2;
const PROGRESS_STROKE_WIDTH = 4;
const INNER_RADIUS = 17;
const CIRCUMFERENCE = 2 * Math.PI * ARC_RADIUS;
const TEXT_FONT_SIZE = 18;
const TEXT_FONT_WEIGHT = 600;
const TRANSITION_STYLE = { transition: "stroke-dashoffset 0.3s ease-in-out" };
const FONT_STYLE = { fontFamily: "var(--font-primary)" };

const CircularProgress = (props: CircularProgressProps) => {
    const isComplete = props.progress >= 100;
    const clampedProgress = Math.min(Math.max(props.progress, 0), 100);
    const offset = CIRCUMFERENCE - (CIRCUMFERENCE * clampedProgress) / 100;

    const progressColor = isComplete ? "var(--color-p6-orange)" : "var(--color-p6-grey-mid)";
    const hasProgress = clampedProgress > 0;
    const innerFill = hasProgress ? "var(--color-white)" : "var(--color-background-light)";

    return (
        <div className="shrink-0">
            <svg
                width={SVG_SIZE}
                height={SVG_SIZE}
                viewBox={`0 0 ${SVG_SIZE} ${SVG_SIZE}`}
                role="img"
                aria-label={`Exercise ${props.number}, ${clampedProgress}% complete`}
            >
                <circle
                    cx={CENTER}
                    cy={CENTER}
                    r={ARC_RADIUS}
                    fill="none"
                    stroke="var(--color-p6-grey-lightest)"
                    strokeWidth={TRACK_STROKE_WIDTH}
                />

                {clampedProgress > 0 && (
                    <circle
                        cx={CENTER}
                        cy={CENTER}
                        r={ARC_RADIUS}
                        fill="none"
                        stroke={progressColor}
                        strokeWidth={PROGRESS_STROKE_WIDTH}
                        strokeDasharray={CIRCUMFERENCE}
                        strokeDashoffset={offset}
                        strokeLinecap="butt"
                        transform={`rotate(-90 ${CENTER} ${CENTER})`}
                        style={TRANSITION_STYLE}
                    />
                )}

                <circle
                    cx={CENTER}
                    cy={CENTER}
                    r={INNER_RADIUS}
                    fill={innerFill}
                />

                <text
                    x={CENTER}
                    y={CENTER}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize={TEXT_FONT_SIZE}
                    fontWeight={TEXT_FONT_WEIGHT}
                    fill="var(--color-p6-grey-dark)"
                    style={FONT_STYLE}
                >
                    {props.number}
                </text>
            </svg>
        </div>
    );
};

export default CircularProgress;
